import { useEffect, useState } from 'react';
import Modal from "../../../common/ModalPopup";
import { Tab } from 'react-bootstrap';
import { getLeadHistory } from '../../../store/slices/insurance';
import dateFormat from "dateformat";
import { useLanguage } from '@src/context/LanguageContext';
import { LEAD_TYPE_CRM } from "@src/config/constant";


function LeadTimelineModal(props: any) {

    const {viewTimeLine, selectedRemarkLead} = props;

    const {translations} = useLanguage();


    const [loading, setLoading] = useState(false);

    const [timelineList, setTimelineList] = useState([]);


    useEffect(()=>{

        if(viewTimeLine){
            setLoading(true);
            getLeadHistory({ lead_id: selectedRemarkLead }).then((res: any) => {
                setLoading(false);

                if (res.data && res.data.length) {
                    setTimelineList(res.data)
                }
            }).catch(err=> setLoading(false));
        }

    // eslint-disable-next-line
    }, [viewTimeLine])


    return (


            <div className="view-timeline-popup image-timeline-popup">
                <Modal show={viewTimeLine} handleClose={() => props.handleViewTimeLine(false, 0)} >
                    <div className="modal-header">
                        <h2>{translations.Insurance?.['Insurance Timeline'] || translations.commonMsg?.loading}</h2>
                    </div>

                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <div className="modal-body" >

                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <table>
                                        <tbody>

                                            {
                                                !loading && timelineList.length
                                                    ?
                                                    timelineList.map((timeline: any, idx: number) =>
                                                        <tr key={idx+1}>
                                                            <td>
                                                                <span className="date">{dateFormat(timeline.created_at, 'd mmm, yyyy')}</span>
                                                                <span className="time">{dateFormat(timeline.created_at, 'hh:MM tt')}</span>
                                                            </td>
                                                            <td>
                                                                {timeline?.comment ?
                                                                    <span className="heading" dangerouslySetInnerHTML={{ __html: timeline.comment }}></span>
                                                                :
                                                                    <><span className="heading">{timeline.status_name}</span><span className="">{timeline.sub_status_name}</span></>
                                                                }
                                                            </td>
                                                            <td>
                                                                {timeline.created_by_name || 'Admin'}
                                                                {timeline.source_name && timeline.source && timeline.source === LEAD_TYPE_CRM && (
                                                                    <span className='badge badge-lead-comming'>
                                                                        ({timeline.source_name})
                                                                    </span>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    )
                                                    :
                                                    loading ? <tr><p style={{ textAlign: "center" }}>{translations.Insurance?.['loading'] || translations.commonMsg?.loading}</p></tr> : <tr><p style={{ textAlign: "center" }}>{translations.commonMsg?.['No data found'] || translations.commonMsg?.loading}</p></tr>

                                            }

                                        </tbody>
                                    </table>

                                </Tab.Pane>

                            </Tab.Content>
                        </div>

                    </Tab.Container>
                </Modal>

            </div>

    )
}

export default LeadTimelineModal;
